import { FastForward, ScanLine } from 'lucide-react';
import { useEffect } from 'react';
import { CASE_001 } from '../case/case001';
import { useGame } from '../game/GameContext';
import { getRevealMoment, REVEAL_DURATION_MS } from '../game/timeline';

export function RevealOverlay() {
  const { state, dispatch } = useGame();
  const moment = getRevealMoment(state.revealElapsedMs);
  useEffect(() => {
    if (state.revealElapsedMs >= REVEAL_DURATION_MS) dispatch({ type: 'FINISH_REVEAL' });
  }, [dispatch, state.revealElapsedMs]);

  return (
    <div className="reveal-ui screen-layer screen-layer--passthrough">
      <header><ScanLine /><span>FORENSIC RECONSTRUCTION</span><strong>{CASE_001.id} / WORLD TRUTH</strong></header>
      <div className="reveal-caption">
        <span>{moment.beat.time} COURT TIME</span>
        <h2>{moment.beat.title}</h2>
        <p>{moment.beat.description}</p>
        <div><i style={{ width: `${moment.progress * 100}%` }} /></div>
      </div>
      <div className="reveal-beats">
        {CASE_001.timeline.map((beat, index) => <i key={beat.id} className={index <= moment.index ? 'is-active' : ''} />)}
      </div>
      <button className="reveal-skip hud-interactive" onClick={() => dispatch({ type: 'FINISH_REVEAL' })}><FastForward /> Skip to verdict</button>
    </div>
  );
}
